module.exports = __webpack_public_path__ + "static/pageloader-2e111b66ba3d2a8a46f5230aa0ee9dd7.gif";